

window.graphNiederschlagData = ( interval, $data ) => {
    $graphData = new Array();

    for ( var d = 0; d < $data.length; d++ ) {
        var item = [ parseInt( $data[ d ][ 0 ] ), 0, 0 ];
        if ( !isNaN( parseFloat( $data[ d ][ 1 ] ) ) ) {
            item[ 1 ] = parseFloat( parseFloat( $data[ d ][ 1 ] ).toFixed( 2 ) );
        } else {
            item[ 1 ] = 'NaN';
        }
        if ( $data[ d ][ 2 ] === '' ) {
            item[ 2 ] = 'NaN';
        } else {
            item[ 2 ] = parseFloat( parseFloat( $data[ d ][ 2 ] ).toFixed( 2 ) );
        }
        $graphData.push( item );
    }
    return $graphData;
}

window.graphNiederschlag = ( el, gLabels, gSeries, $labelFirst, legendContainer, allG, data, barWidth, allLabels, colors, $title, warnings ) => {
    barWidth = barWidth || 0;
    allLabels = allLabels || false;
    colors = colors || null;
    $title = $title || null;
    warnings = warnings || null;
    //allLabels = false;
    if ( data ) {
        $graphData = data;
    }
    var temp = $graphData;

    if ( typeof ( temp ) === 'string' ) {
        temp = $.csv.toArrays( $graphData );
        $graphData = temp;
    }
    // console.log(temp);
    var max = temp.MaxTimeLine();
    for ( var i = 0; i < $graphData.length; i++ ) {
        if ( $graphData[ i ][ 1 ] > max ) {
            max = $graphData[ i ][ 1 ];
        }
        if ( $graphData[ i ][ 2 ] > max ) {
            max = $graphData[ i ][ 2 ];
        }
    }
    if ( max > 10 ) {
        max = max - max % 10 + 10;
    } else {
        max = NaN;
    }

    var min = 0;
    if ( warnings !== null ) {
        for ( var w = 0; w < warnings.length - 1; w++ ) {
            if ( max < warnings[ w ][ 1 ] ) {
                max = warnings[ w ][ 1 ];
                max = max - max % 10 + 20;
            }
        }
    }
    // WUPSUPP-119 "NaN" !== NaN
    for ( var i = 0; i < $graphData.length; i++) {
        for(var n=0; n<3;n++) {
            $graphData[i][n] = parseFloat($graphData[i][n]);
        }
    }

    var graph = new Dygraph(
        el,
        $graphData, {
            underlayCallback: function ( canvas, area, g ) {
                if ( warnings !== null ) {
                    g.warnings = warnings;
                    dyDrawWarnings( canvas, area, g, warnings );

                }
            },
            smColors: colors,
            xRangePad: barWidth,
            labelsSeparateLines: true,
            pointSize: 2,
            drawPoints: true,
            valueRange: [ min, max ],
            connectSeparatedPoints: false,
            drawGapEdgePoints: true,
            includeZero: true,
            labels: gLabels,
            series: gSeries,
            title: ( $title || $labelFirst ),
            height: 400,
            xAxisHeight: 50,
            pixelsPerLabel: 40,
            drawAxesAtZero: true,
            legend: 'allways',
            showLabelsOnHighlight: true,
            hideOverlayOnMouseOut: false,
            //labelsDiv : legendContainer,
            ylabel: ( $( el ).attr( 'data-legend' ) ? $( el ).attr( 'data-legend' ) : "Wasserstand" ),
            labelsDivWidth: 0,
            legendFormatter: legendFormatter,
            interactionModel: {},	// ZOOM deaktiviert

            axes: {
                y: { valueFormatter: function ( ms ) { return ms.toFixed( 2 ); } },
                x: {
                    ticker: function ( min, max, pixels, opts, dygraph, vals ) {
                        var fullData = dygraph.rawData_;
                        var tickVals = new Array();
                        var xAxisStep = 1;
                        if ( dygraph.xAxisStep ) {
                            xAxisStep = dygraph.xAxisStep;
                        }
                        for ( var i = 0; i < dygraph.rawData_.length; i++ ) {
                            var ts = dygraph.rawData_[ i ][ 0 ];
                            if ( i % xAxisStep === 0 ) {
                                var date = new Date( ts * 1000 );
                                var month = date.getMonth() + 1;
                                var day = date.getDate();
                                var hour = date.getHours();
                                min = date.getMinutes();
                                month = ( month < 10 ? "0" : "" ) + month;
                                day = ( day < 10 ? "0" : "" ) + day;
                                hour = ( hour < 10 ? "0" : "" ) + hour;
                                min = ( min < 10 ? "0" : "" ) + min;
                                var sep = ":";
                                if ( xAxisStep === 1 ) {
                                    // Tägliche Anzeige ohne Zeit
                                    hour = "";
                                    min = "";
                                    sep = "";
                                }
                                //console.debug(dygraph.rawData_[i][0]);
                                var t = { v: dygraph.rawData_[ i ][ 0 ], label: '<span class="dia-date" style="font-weight: bold">' + day + '.' + month + '</span><br /><span class="dia-time">' + hour + sep + min + '</span>' };
                                tickVals.push( t );
                            }
                        }
                        if ( Math.ceil( dygraph.rawData_.length / xAxisStep ) !== tickVals.length ) {
                            console.log( "Data missmatch: " + Math.ceil( dygraph.rawData_.length / xAxisStep ) + " !== " + tickVals.length );
                        }
                        return tickVals;
                    },
                    //valueFormatter: function (ts) {
                    //	var date = new Date(ts * 1000);
                    //                   var month = date.getMonth() + 1;
                    //                   var day = date.getDate();
                    //                   var hour = date.getHours();
                    //                   var min = date.getMinutes();
                    //                   var sec = date.getSeconds();
                    //                   month = (month < 10 ? "0" : "") + month;
                    //                   day = (day < 10 ? "0" : "") + day;
                    //                   hour = (hour < 10 ? "0" : "") + hour;
                    //                   min = (min < 10 ? "0" : "") + min;
                    //	sec = (sec < 10 ? "0" : "") + sec;
                    //	var d = new Date().getTime()
                    //	if (ts * 1000 > new Date().getTime()) {
                    //		console.debug("G");
                    //		day += "D";
                    //	}
                    //                   if (this.rawData_.length < 20) {
                    //                       return day + '.' + month + '.' + date.getFullYear();
                    //                   } else {
                    //                       return day + '.' + month + '.' + date.getFullYear() + " " + hour + ":" + min + ":" + sec;
                    //                   }
                    //               }
                }
            },
            highlightCallback: function ( event, x, points, row, seriesName ) {
                $( '.highlightedTime' ).html( getFormatTime( x ) );
                $( '.dia-value span' ).html( '' );
                $this = this;
                var isDay = $this.file_.length < 11;
                var nextV = '';
                $( points ).each( function ( i, el ) {
                    var legendElName = el.name.replace( /\/|³|²|\s|\[|\]/gi, '_' );
                    var v = ( el.yval === 'NaN' ? '' : el.yval );

                    if ( isDay && new Date( el.xval * 1000 ).toDateString() === new Date().toDateString() && legendElName === 'Niederschlag__mm_' ) {
                        //console.debug(new Date(el.xval * 1000).toDateString() + " === " + new Date().toDateString());
                        $( '.' + legendElName ).html( v );
                        nextV = v;
                        legendElName = 'Vorhersage__mm_';
                    }

                    v = ( nextV !== '' ? nextV : v );
                    $( '.' + legendElName ).html( v );
                } );
            },
            drawCallback: function ( me, initial ) {
                if ( me.tabClicked ) {
                    $( legendContainer ).html( me.attributes_.labels_[ 0 ] );
                    me.tabClicked = false;
                    $( legendContainer ).show();
                }
                if ( initial ) {
                    if ( allG[ 0 ] ) {
                        $( legendContainer ).html( allG[ 0 ].attributes_.labels_[ 0 ] );
                        $( legendContainer ).show();
                    }
                }
            }
        }
    );
    return graph;
}

window.legendFormatter = (data) => {
    if (data.x == null) {
        // This happens when there's no selection and {legend: 'always'} is set.
        return '<br>' + data.series.map(function(series) {
            return series.dashHTML + ' ' + series.labelHTML
        }).join('<br>');
    }

    var html = '';//this.getLabels()[0] + '' + data.xHTML;
    data.series.forEach(function(series) {
        if (!series.isVisible) return;
        var labeledData = '<div style="color: ' + series.color + '">' + series.labelHTML + ': ' + series.yHTML;
        if (series.isHighlighted) {
            labeledData = '<b>' + labeledData + '</b>';
        }
        html += labeledData + '</div>';
        // html = html.replace('border-bottom-','');
    });
    return html;
}
